module.exports = __webpack_public_path__ + "img/htclogo.55bb6dd5.jpg";